import columns from "../../../../../../react-table/helpers/columns";
import ReportDefinitions from "../../../../../../common/config/ReportDefinitions";

export function getDetailsTabNavigationProps(rowInfo) {
  return rowInfo && rowInfo.row
    ? {
        reportId:
          ReportDefinitions.PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_DETAILS.id,
        mainReportId:
          ReportDefinitions.PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_SUMMARY.id,
        requestParams: {
          impcFrom: rowInfo.row["originImpc.impc"], // eslint-disable-line
          impcTo: rowInfo.row["destinationImpc.impc"], // eslint-disable-line
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      }
    : {};
}

export const destinationImpcSpecialTypeConditionalProps = (state, rowInfo) => {
  let className = "";
  if (rowInfo) {
    if (rowInfo.row["destinationImpc.specialType"] === "M") {
      className = "bg-orange-amber-bold";
    }
  }
  return {
    className,
  };
};

export default (data) => {
  const { TextColumn, NonZeroNumberColumn, NavigationColumn } = columns(data);

  return [
    {
      Header: "",
      columns: [
        new TextColumn("Origin operator", "originImpc.operator"),
        new TextColumn("Origin IMPC", "originImpc.impc"),
        new TextColumn("Destination operator", "destinationImpc.operator"),
        new TextColumn("Destination IMPC", "destinationImpc.impc").withWidth(
          140
        ),
        new NavigationColumn(
          new NonZeroNumberColumn("Despatch count", "despatchCount").withWidth(
            120
          ),
          getDetailsTabNavigationProps
        ),
      ],
    },
    {
      Header: "Origin IMPC code - errors",
      columns: [
        new NonZeroNumberColumn("Function", "originImpcCodeErrors.function"),
        new NonZeroNumberColumn(
          "Validity period",
          "originImpcCodeErrors.validityPeriod"
        ).withWidth(120),
        new NonZeroNumberColumn("Flow", "originImpcCodeErrors.flow"),
        new NonZeroNumberColumn(
          "Mail category - A",
          "originImpcCodeErrors.mc.a"
        ).withWidth(120),
        new NonZeroNumberColumn(
          "Mail category - B",
          "originImpcCodeErrors.mc.b"
        ).withWidth(120),
        new NonZeroNumberColumn(
          "Mail category - C",
          "originImpcCodeErrors.mc.c"
        ).withWidth(120),
        new NonZeroNumberColumn(
          "Mail category - D",
          "originImpcCodeErrors.mc.d"
        ).withWidth(120),
        new NonZeroNumberColumn(
          "Mail class - U",
          "originImpcCodeErrors.mcl.u"
        ).withWidth(120),
        new NonZeroNumberColumn(
          "Mail class - C",
          "originImpcCodeErrors.mcl.c"
        ).withWidth(120),
        new NonZeroNumberColumn(
          "Mail class - E",
          "originImpcCodeErrors.mcl.e"
        ).withWidth(120),
        new NonZeroNumberColumn(
          "Mail class - T",
          "originImpcCodeErrors.mcl.t"
        ).withWidth(120),
      ],
    },
    {
      Header: "Destination IMPC code - errors",
      columns: [
        new NonZeroNumberColumn(
          "Function",
          "destinationImpcCodeErrors.function"
        ),
        new NonZeroNumberColumn(
          "Validity period",
          "destinationImpcCodeErrors.validityPeriod"
        ).withWidth(120),
        new NonZeroNumberColumn("Flow", "destinationImpcCodeErrors.flow"),
        new NonZeroNumberColumn(
          "Mail category - A",
          "destinationImpcCodeErrors.mc.a"
        ).withWidth(120),
        new NonZeroNumberColumn(
          "Mail category - B",
          "destinationImpcCodeErrors.mc.b"
        ).withWidth(120),
        new NonZeroNumberColumn(
          "Mail category - C",
          "destinationImpcCodeErrors.mc.c"
        ).withWidth(120),
        new NonZeroNumberColumn(
          "Mail category - D",
          "destinationImpcCodeErrors.mc.d"
        ).withWidth(120),
        new NonZeroNumberColumn(
          "Mail class - U",
          "destinationImpcCodeErrors.mcl.u"
        ).withWidth(120),
        new NonZeroNumberColumn(
          "Mail class - C",
          "destinationImpcCodeErrors.mcl.c"
        ).withWidth(120),
        new NonZeroNumberColumn(
          "Mail class - E",
          "destinationImpcCodeErrors.mcl.e"
        ).withWidth(120),
        new NonZeroNumberColumn(
          "Mail class - T",
          "destinationImpcCodeErrors.mcl.t"
        ).withWidth(120),
      ],
    },
    {
      Header: "Origin IMPC",
      columns: [
        new TextColumn("Special type", "originImpc.specialType"),
        new TextColumn(
          "Bilateral agreement",
          "originImpc.bilateralAgreement"
        ).withWidth(140),
      ],
    },
    {
      Header: "Destination IMPC",
      columns: [
        new TextColumn(
          "Special type",
          "destinationImpc.specialType"
        ).withGetProps(destinationImpcSpecialTypeConditionalProps),
        new TextColumn(
          "Bilateral agreement",
          "destinationImpc.bilateralAgreement"
        ).withWidth(140),
      ],
    },
  ];
};
